"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _variables = _interopRequireDefault(require("../utils/variables"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var styles = function styles(theme) {
  return {
    input: {
      "&:after": {
        borderBottom: "2px solid ".concat(_variables["default"].primaryTheme || theme.palette.primary.main)
      }
    },
    inputLabel: {
      color: "rgba(0, 0, 0, 0.54)",
      "&$inputLabelfocused": {
        color: "rgba(0, 0, 0, 0.54)"
      }
    },
    inputLabelfocused: {},
    selectIcon: {
      top: "calc(50% - 5px)"
    }
  };
};

var _default = styles;
exports["default"] = _default;